import React from 'react';
import { ChevronDown } from 'lucide-react';

type CategoryFilterTriggerProps = {
	selectedCount: number;
	onClick: () => void;
	disabled?: boolean;
};

const CategoryFilterTrigger = ({ selectedCount, onClick, disabled = false }: CategoryFilterTriggerProps) => {
	return (
		<button
			onClick={onClick}
			disabled={disabled}
			className="flex md:hidden items-center gap-2 rounded-lg border-none hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
		>
			<span className="text-sm font-medium text-[#4A5568]">Category</span>

			{selectedCount > 0 && (
				<span className="inline-flex items-center justify-center w-5 h-5 text-xs font-semibold text-[#812973] bg-[#F8EAFF] rounded-full">
					{selectedCount}
				</span>
			)}

			<ChevronDown size={16} className="text-gray-600" />
		</button>
	);
};

export default CategoryFilterTrigger;
